<template>
  <div class="card-sakali container-fluid pb-1 mt-2 mx-0" v-if="matches">
    <div class="row pb-2" v-for="(m, index) in matches" :key="m.id"
         :class="{'border-top border-sakali-highlight pt-2':index !== 0,
                      'pb-0 mb-0':index === matches.length -1,
                      'sakali-highlight':m === selectedMatch,
                  'even': index % 2 === 1}"
         @click="$emit('select', m); $emit('toggle-view')">
      <div class="col-8 col-md-10 ps-1 text-truncate text-nowrap">
        <div class="row px-md-2">
          <div class="col-12">
            <team-emblem size="21" :emblem-id="m.team1.emblemId" :shadow="false"/>
            <span class="ms-1" :class="{'font-weight-lighter text-secondary':ko && m.goalsTeam1 > m.goalsTeam2}">{{ m.team1.name }}</span>
            <div class="d-none d-md-inline-block text-secondary align-text-bottom ps-1 small">
              -
              <sakali-user :user="m.team1.coach" :show-avatar="false"/>
            </div>
          </div>
          <div class="col-12">
            <team-emblem size="21" :emblem-id="m.team2.emblemId" :shadow="false"/>
            <span class="ms-1" :class="{'font-weight-lighter text-secondary':ko && m.goalsTeam1 < m.goalsTeam2}">{{ m.team2.name }}</span>
            <div class="d-none d-md-inline-block text-secondary align-text-bottom ps-1 small">
              -
              <sakali-user :user="m.team2.coach" :show-avatar="false"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="started(m)"
           class="col-4 col-md-2 pe-1 ps-md-0 text-dark text-nowrap text-end "
           :class="{'live':!finished(m), 'text-end':m.half === 0}">
        <span class="result">{{ m.goalsTeam1 }}:{{ m.goalsTeam2 }}</span>
        <span style="font-size: 1.3rem;" class="align-text-bottom ms-1">
            <span v-if="m.half == 2">({{ m.halfGoalsTeam1 }}:{{ m.halfGoalsTeam2 }})</span>
            <span v-if="!finished(m) && m.inOvertime">i.V.</span>
            <span v-if="finished(m) && m.inOvertime">n.V.</span>
            <span v-if="!finished(m) && m.inPenaltyShootout">i.E.</span>
            <span v-if="finished(m) && m.inPenaltyShootout">n.E.</span>
          </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    matches: Array,
    selectedMatch: Object,
    ko: Boolean
  },
  methods: {
    finished(m) {
      return m.state === 'FINISHED'
    },
    started(m) {
      return m.state === 'RUNNING' || this.finished(m)
    },
    toggleView() {
      this.$emit('toggle-view');
    },
  }
}
</script>
